import {
    apiRequest,
    riwayatsumpahDetail,
    riwayatsumpahUpdate,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/riwayatsumpahService"

class UpdateRepository {

    fetchRegionCountry = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatsumpahDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", riwayatsumpahUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository